[
  {
    "code": "BH-14",
    "name": "Al Janubiyah"
  },
  {
    "code": "BH-13",
    "name": "Al Manamah"
  },
  {
    "code": "BH-15",
    "name": "Al Muharraq"
  },
  {
    "code": "BH-16",
    "name": "Al Wustá"
  },
  {
    "code": "BH-17",
    "name": "Ash Shamaliyah"
  }
]